export const ROUTES = {
  vacations: {
    manageMyBooking: "/vacations/manage-my-booking",
  },
};
